// inputs.js
import { validateRequired,validateLength, validateNotNull,validateNonZeroInteger }from "../../../../helpers/validationsForm";

const Inputs = [
    {
    id: 1,
    label: "Codigo",
    name: "depa_codigo",
    type: "text",
    placeholder: "Ingrese el codigo",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }
      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Descripcion",
    name: "loc_descripcion",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Abreviatura",
    name: "loc_abrev",
    type: "text",
    placeholder: "Ingrese la Abreviatura",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 5 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 4,
    label: "Visibilidad",
    name: "loc_show_web",
    type: "select",
    options: [
      { value: 0, label: "Visible" },
      { value: 1, label: "Oculto" }
    ],
    validation: (value, form) => {
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }
      return null;
    }
  },
  {
    id: 5,
    label: "Provincia",
    name: "pcia_id",
    type: "select",
    placeholder: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 6,
    label: "Departamento",
    name: "depa_id",
    type: "select",
    placeholder: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  }, 
];

export default Inputs;
